import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getAgencies = (filters, token) =>
    axios({
        method: 'get',
        url: `${api}/agencies?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
        }
    });

export const postAgencies = (agency, token) =>
    axios({
        method: 'post',
        url: `${api}/agencies`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/agencies`
        },
        data: agency
    });

export const putAgencies = (agency, token) =>
    axios({
        method: 'put',
        url: `${api}/agencies/${agency._id}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/agencies`
        },
        data: agency
    });